module.exports = __webpack_public_path__ + "static/img/hexibanner2.250137fd.jpg";